import React, { useEffect } from "react";
import Hero from "./landing/sections/Hero";
import StatsStrip from "./landing/sections/StatsStrip";
import PromiseBanner from "./landing/sections/PromiseBanner";
import ProblemSection from "./landing/sections/ProblemSection";
import HowItWorks from "./landing/sections/HowItWorks";
import CaseStudies from "./landing/sections/CaseStudies";
import ServiceTiers from "./landing/sections/ServiceTiers";
import { LeadFormProvider } from "./landing/lead-form/LeadFormProvider";
import type { Pricing } from "./landing/business-case/calculator";

// The page's own anchors jump the length of the page in one frame otherwise. Scoped to the landing
// page's lifetime.
function useSmoothAnchorScroll() {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    const root = document.documentElement;
    const previous = root.style.scrollBehavior;
    root.style.scrollBehavior = "smooth";

    return () => {
      root.style.scrollBehavior = previous;
    };
  }, []);
}

type Props = {
  pricing: Pricing;
  pricingUrl: string;
  businessCaseUrl: string;
};

export default function LandingPage({ pricing, pricingUrl, businessCaseUrl }: Props) {
  useSmoothAnchorScroll();

  return (
    <LeadFormProvider>
      <Hero promise={pricing.promise} businessCaseUrl={businessCaseUrl} />
      <StatsStrip />
      <PromiseBanner promise={pricing.promise} />
      <ProblemSection />
      <HowItWorks />
      <CaseStudies />
      <ServiceTiers pricingUrl={pricingUrl} />
    </LeadFormProvider>
  );
}
